import { Dispatch, SetStateAction } from "react";

export interface SelectionType {
	containerId?: string;
	elementId?: string;
}

export interface SelectionActions {
	selectContainer: (containerId: string) => void;
	selectElement: (elementId: string) => void;
	unselectElement: () => void;
	unselectContainer: () => void;
}

export function selectionActionsHelper(
	setElementEditing: Dispatch<SetStateAction<ContainerElementRef | undefined>>,
	setContainerEditing: Dispatch<SetStateAction<string | undefined>>,
	elementsPositionMap: FunctionalMap<string, ContainerElementRef>
): SelectionActions {
	return {
		unselectContainer() {
			setContainerEditing(undefined);
		},
		unselectElement() {
			setElementEditing(undefined);
		},
		selectContainer(containerId) {
			setContainerEditing(containerId);
		},
		selectElement(elementId) {
			setElementEditing(elementsPositionMap.get(elementId));
		}
	};
}
